// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-sidebar {
  width: 220px;
  padding: 0.5rem;
}

.stepper-sidebar-steps {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.stepper-sidebar-steps > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.stepper-sidebar-item {
  position: relative;
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
}

.stepper-sidebar-item > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.stepper-sidebar-item {
  border-radius: 0.5rem;
  border-color: transparent;
  padding: 0.5rem;
}
.stepper-sidebar-item.active {
  background: var(--color-bg-light);
}
.stepper-sidebar-item.active .stepper-sidebar-item-icon {
  color: var(--color-txt);
}
.stepper-sidebar-item .stepper-sidebar-item-icon {
  color: var(--color-light);
}

.stepper-sidebar-item.active .stepper-sidebar-item-step {
  border-color: rgb(var(--color-scale-gray-9));
  background-color: rgb(var(--color-scale-gray-9));
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
    font-weight: medium;
}

.stepper-sidebar-item.active .stepper-sidebar-item-label {
  font-weight: 500;
  color: var(--color-text-primary);
    font-weight: medium;
}

.stepper-sidebar-item-step {
  display: flex;
  height: 1.25rem;
  width: 1.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 1px;
  border-color: rgb(var(--color-scale-gray-3));
  background-color: rgb(var(--color-scale-gray-2));
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: rgb(var(--color-scale-gray-4));
    font-weight: medium;
}

.stepper-sidebar-item-label {
  font-weight: 400;
  color: rgb(var(--color-scale-gray-5));
    font-weight: normal;
}

.stepper-sidebar-item-line {
  position: absolute;
  left: 8px;
  bottom: 0px;
  margin-bottom: -14px;
  height: 14px;
  width: 0px;
  background-color: rgb(var(--color-scale-gray-3));
}

.stepper-sidebar-item:last-child > .stepper-sidebar-item-line {
  display: none;
}

.stepper-step-indicator .stepper-step-indicator-progress {
  height: 100%;
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
  background-color: rgb(var(--color-theme));
}
.stepper-step-indicator .stepper-step-indicator-wrapper {
  height: 0.375rem;
  width: 100%;
  overflow: hidden;
  border-radius: 9999px;
  --tw-shadow: rgb(225 228 232 / 20%) 0px 1px 0px inset;
  --tw-shadow-colored: inset 0px 1px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  background: rgb(var(--color-scale-gray-2));
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/stepper/stepper.component.scss"],"names":[],"mappings":"AAEE;EAAA,YAAA;EAAA,eAAA;AAAA;;AAGA;EAAA,aAAA;EAAA,WAAA;EAAA,sBAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA,wDAAA;AAAA;;AAGA;EAAA,kBAAA;EAAA,oBAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,2BAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA,+DAAA;AAAA;;AAAA;EAAA,qBAAA;EAAA,yBAAA;EAAA,eAAA;AAAA;AAEA;EACE,iCAAA;AAEJ;AAAI;EACE,uBAAA;AAEN;AAEE;EACI,yBAAA;AAAN;;AAIE;EAAA,4CAAA;EAAA,gDAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,gDAAA;IAAA,mBAAA;AAAA;;AAGA;EAAA,gBAAA;EAAA,gCAAA;IAAA,mBAAA;AAAA;;AAGA;EAAA,aAAA;EAAA,eAAA;EAAA,cAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,iBAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,qCAAA;IAAA,mBAAA;AAAA;;AAGA;EAAA,gBAAA;EAAA,qCAAA;IAAA,mBAAA;AAAA;;AAGA;EAAA,kBAAA;EAAA,SAAA;EAAA,WAAA;EAAA,oBAAA;EAAA,YAAA;EAAA,UAAA;EAAA,gDAAA;AAAA;;AAEF;EACE,aAAA;AAKF;;AAAI;EAAA,YAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,yCAAA;AAAA;AAGA;EAAA,gBAAA;EAAA,WAAA;EAAA,gBAAA;EAAA,qBAAA;EAAA,qDAAA;EAAA,6DAAA;EAAA,uGAAA;EACA,0CAAA;AADA;AAoEJ,4pGAA4pG","sourcesContent":["\n.stepper-sidebar {\n  @apply w-[220px] p-2;\n}\n.stepper-sidebar-steps {\n  @apply flex flex-col space-y-1 w-full;\n}\n.stepper-sidebar-item {\n  @apply inline-flex items-center justify-start space-x-2 relative w-full p-2 rounded-lg border-transparent;\n\n  &.active {\n    background: var(--color-bg-light);\n\n    .stepper-sidebar-item-icon {\n      color: var(--color-txt);\n    }\n  }\n\n  .stepper-sidebar-item-icon {\n      color: var(--color-light);\n  }\n}\n.stepper-sidebar-item.active .stepper-sidebar-item-step {\n  @apply bg-gray-900 border-gray-900 text-white font-medium;\n}\n.stepper-sidebar-item.active .stepper-sidebar-item-label {\n  @apply font-medium text-color-text-primary;\n}\n.stepper-sidebar-item-step {\n  @apply bg-gray-200 border-gray-300 text-gray-400 w-5 h-5 rounded-full border flex items-center justify-center font-medium text-sm;\n}\n.stepper-sidebar-item-label {\n  @apply text-gray-500 font-normal;\n}\n.stepper-sidebar-item-line {\n  @apply absolute -mb-[14px] left-[8px] h-[14px] w-0 bg-gray-300 bottom-0;\n}\n.stepper-sidebar-item:last-child > .stepper-sidebar-item-line {\n  display: none;\n}\n\n.stepper-step-indicator {\n  .stepper-step-indicator-progress {\n    @apply  bg-primary h-full rounded-r-full;\n  }\n  .stepper-step-indicator-wrapper {\n    @apply h-1.5 w-full rounded-full overflow-hidden shadow-inner;\n    background: rgb(var(--color-scale-gray-2));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
